export enum Step {
  HALF = 1,
  WHOLE = 2,
  OCTAVE = 12
}
